export const bsaCTRStatuses = [
  { label: 'New', value: 'new' },
  { label: 'Approved', value: 'approved' },
  { label: 'Cancelled', value: 'cancelled' },
  { label: 'Submitted', value: 'submitted' },
  { label: 'Acknowledged with warnings', value: 'acknowledged_with_warnings' },
  { label: 'Acknowledged', value: 'acknowledged' }
]
